/*
 * Copyright © 2021-present Tacnode Inc. All rights reserved.
 * The information contained in this software is confidential and proprietary to Tacnode Inc. and its subsidiaries. No part of this software may be used, copied, reproduced, modified, displayed, performed, executed, published, distributed, conveyed, stored, transmitted, or otherwise exploited in any form or by any means, including but not limited to electronic, mechanical, photocopying, recording, transcribing, without the prior written consent of Tacnode Inc.
 * Any violation of the above terms will constitute an infringement of copyright and will be subjected to legal action.
 */
import { UserOutlined, SkinOutlined } from '@ant-design/icons'
import { TableColumnsType } from 'antd'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { CommonRole } from 'account-client'
import { GrantRoleToUser } from '@/pages/auth/features/GrantRoleToUser'
import { RevokeRoleFromUser } from '@/pages/auth/features/RevokeRoleFromUser'
import { RoleDescription } from '@/pages/auth/features/RoleDescription'
import { TRoleName, TRoleType } from '@/pages/auth/interface'

export function useRolesColumns() {
  const { t } = useTranslation()

  const columns = useMemo<TableColumnsType<CommonRole>>(
    () => [
      {
        title: t('Role'),
        dataIndex: 'name',
        render: value => <Link to={value}>{value}</Link>,
      },
      {
        title: t('Role Description'),
        dataIndex: 'name',
        width: '20%',
        render: (value: TRoleName) => (
          <span className="description-text">
            <RoleDescription roleName={value} />
          </span>
        ),
      },
      // {
      //   title: t('Number of Authorized Users'),
      //   width: 100,
      //   render: (record: CommonRole) => record.children?.filter(({ type }: any) => type === 'user').length,
      // },
      {
        // title: (
        //   <>
        //     <SkinOutlined />
        //     {t('Roles')} / <UserOutlined />
        //     {t('Users')}
        //   </>
        // ),
        title: t('Members'),
        dataIndex: 'children',
        render: (value, record) =>
          value?.map((item: CommonRole) => (
            <RevokeRoleFromUser key={item.name} style="tag" roleType={item.type as TRoleType} role={record.name} userName={item.name} />
          )),
      },
      {
        title: t('Actions'),
        dataIndex: 'name',
        width: 150,
        render: value => <GrantRoleToUser role={value} size="small" />,
      },
    ],
    [],
  )

  return columns
}
